import { render } from "./goalView.vue?vue&type=template&id=bd77d968&scoped=true"
import script from "./goalView.vue?vue&type=script&lang=js"
export * from "./goalView.vue?vue&type=script&lang=js"

import "./goalView.vue?vue&type=style&index=0&id=bd77d968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd77d968"]])

export default __exports__